import React from 'react';

type Props = {
  count: number;
};

const CounterView: React.FC<Props> = ({ count }) => {
  return (
    <>
      <div className="my-2 mx-2  min-w-1/4 max-w-1/3 bg-surface-variant  rounded-full">
        <button
          className={` bg-primary/10 text-center align-center text-lg font-bold text-on-surface-variant rounded-full w-full  h-full cursor-default`}
        >
          {count}
        </button>
      </div>
    </>
  );
};

export default CounterView;
